module.exports = __webpack_public_path__ + "07_mole.b0fe9013.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/07_mole.png
// module id = bVjt
// module chunks = 0